import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import {
    CodeBlock, BlockType, SettingType, Setting, TibboDataType, ValidationMessage, IOMode,
} from '@appblocks/codegeneration/types';
import IOTibbit from '@appblocks/codegeneration/Tibbits/_IOTibbit';

export default class Tibbit_54 extends IOTibbit {
    constructor() {
        super();
        this.id = 'tibbit_54';
        this.name = 'Tibbit 54';
        this.lines = 4;
        this.mode = IOMode.INPUT;
        this.initLines();
    }
}
